export class ContactModel{
    id: number;
    name: string;
    email: string;
    subject: string;
    message: string;
}



// WEBPACK FOOTER //
// ./src/app/Models/contact.model.ts